<template lang="pug">
    v-dialog(
        v-model='dialog'
        max-width="600"
        persistent
        transition='dialog-bottom-transition'
    )
        v-card
            v-toolbar(dark color='warning')
                v-toolbar-title Incoming Transfer

            v-card-text
                template(v-if="validPendingCallTransfer")
                    v-list(two-line)
                        template
                            v-list-item
                                v-list-item-content
                                    v-list-item-title {{ pendingCallTransfer.assigned_campaign_customer.organization_name }}
                                    v-list-item-subtitle.text--primary(v-text='pendingCallTransfer.assigned_campaign_customer.campaign_name')

                        //- template
                        //-     v-divider(inset)
                        //-     v-list-item
                        //-         v-list-item-icon
                        //-             v-icon(color='primary')
                        //-                 | mdi-phone
                        //-         v-list-item-content
                        //-             v-list-item-title {{ pendingIncomingCall.call_communication_queue.communication_queue_name }}
                        //-             v-list-item-subtitle {{ pendingIncomingCall.call_communication_queue.language_name }}

                        //- template
                        //-     v-divider(inset)
                        //-     v-list-item
                        //-         v-list-item-icon
                        //-             v-icon(color='primary')
                        //-                 | mdi-magnify
                        //-         v-list-item-content
                        //-             v-list-item-title
                        //-                 template(v-if="pendingIncomingCall.call_communication_queue.customer_match_code === 1") Perfect
                        //-                 template(v-else-if="pendingIncomingCall.call_communication_queue.customer_match_code === 2") Multiple potential customers found
                        //-                 template(v-else) No customer matches
                        //-             v-list-item-subtitle Match Status

                        template
                            v-divider(inset)
                            v-list-item
                                v-list-item-icon
                                    v-icon(color='primary')
                                        | mdi-account
                                v-list-item-content
                                    v-list-item-title
                                        template(v-if="pendingCallTransfer.current_call.agent_call === true") {{ pendingCallTransfer.current_call.friendly_to_number | tel }}
                                        template(v-else) {{ pendingCallTransfer.current_call.friendly_from_number | tel }}
                                    v-list-item-subtitle Caller ID
                            v-list-item(v-if="validCustomerFullName")
                                v-list-item-icon
                                v-list-item-content
                                    v-list-item-title {{ pendingCallTransfer.assigned_campaign_customer.customer.full_name }}
                                    v-list-item-subtitle Name

                            v-divider(inset)
                            v-list-item
                                v-list-item-icon
                                v-list-item-content
                                    v-list-item-title Notes
                                    v-list-item-subtitle
                                        template(v-if="validNotes") {{ pendingCallTransfer.call_transfer.notes }}
                                        template(v-else) ---

                        v-row(align='center' justify="center")

                            v-tooltip(top)
                                template(v-slot:activator='{ on, attrs }')
                                    v-btn.mx-12.mt-4(v-bind='attrs' v-on='on' fab dark color='error' @click="handleAction(false, true);")
                                        v-icon(dark)
                                            | mdi-phone-hangup
                                span Decline Call

                            v-tooltip(top)
                                template(v-slot:activator='{ on, attrs }')
                                    v-btn.mx-12.mt-4(v-bind='attrs' v-on='on' fab dark color='green' @click="handleAction(true);")
                                        v-icon(dark)
                                            | mdi-phone
                                span Accept Call

</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        data() {
            return {
                dialog: true,
                ringingAudio: null,
                ringingAudioUrl: "https://volie-assets.s3.us-east-1.amazonaws.com/system/audio/phone_ringing_soft.mp3",
                systemAutoDeclineDuation: 13, // default
                timerDuration: 0,
                timerInterval: null,
            }
        },
        methods: {
            handleAction(accept, userClicked) {

                // Stop ringing
                this.stopRinging();

                // Stop timer
                this.stopTimer();

                // Close modal
                this.dialog = false;

                return accept === true ? this.acceptCallTransfer() : this.declineCallTransfer(userClicked === true);
            },
            incrementTimer() {
                this.timerDuration += 1;
            },
            initRingingAudio() {
                if (!this.ringingAudioUrl) {
                    return;
                }

                this.ringingAudio = new Audio(this.ringingAudioUrl);
            },
            playRinging() {
                if (!this.ringingAudio) {
                    return;
                }

                this.ringingAudio.play().catch(() => {});
            },
            startTimer() {
                this.timerInterval = setInterval(this.incrementTimer, 1000);
            },
            stopRinging() {
                if (!this.ringingAudio) {
                    return;
                }

                this.ringingAudio.pause();
            },
            stopTimer() {
                if (!this.timerInterval) {
                    return;
                }

                clearInterval(this.timerInterval);
            },
        },
        computed: {
            validCustomerFullName() {
                return this.pendingCallTransfer?.assigned_campaign_customer?.customer?.customer_id > 0 && this.pendingCallTransfer.assigned_campaign_customer?.customer?.full_name?.length > 0;
            },
            validNotes() {
                return this.pendingCallTransfer?.call_transfer?.notes?.length > 0;
            },
            validPendingCallTransfer() {
                return this.pendingCallTransfer?.call_transfer?.id > 0 && this.pendingCallTransfer?.call_transfer?.transfer_status === "pending";
            },
        },
        components: {
        },
        props: {
            acceptCallTransfer: Function,
            declineCallTransfer: Function,
            pendingCallTransfer: Object,
        },
        watch: {
            timerDuration() {
                return this.dialog === true && this.timerDuration === this.systemAutoDeclineDuation ? this.handleAction(false, false) : null;
            },
        },
        created() {
            this.initRingingAudio();
            this.playRinging();
            this.startTimer();
        },
        destroyed() {
            this.stopRinging();
            this.stopTimer(); // to be safe in avoiding memory leaks
        },
    });
</script>

<style lang="scss" scoped>
</style>
